import { useMembershipContent } from "../../../common/redux/membershipContent";

const getPlaceholderFromDTO = (statePlaceholder: string) => {
  const { productionStep } = useMembershipContent();

  switch (statePlaceholder) {
    case "Risk-Protection Production":
      return productionStep.monetaryProductionRiskProtectionPlaceholder;

    case "Other New Business":
      return productionStep.monetaryProductionOtherNewBusinessPlaceholder;

    case "Total Income Reported":
      return productionStep.monetraryProductionTotalIncomeReportedLabel;

    case "Risk-Protection Policies / Cases":
      return productionStep.riskProtectionPoliciesColumnLabel;

    case "Other Policies / Cases":
      return productionStep.otherNewBusinessPoliciesColumnLabel;

    case "New Business Policies / Cases":
      return productionStep.monetaryProductionOtherNewBusinessPlaceholder;

    default:
      return "";
  }
};

export default getPlaceholderFromDTO;
